import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjectService } from '../services/project.service';

@Injectable({
  providedIn: 'root'
})
export class ConventionGuard implements CanActivate {

  constructor(private _projectService: ProjectService, private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._projectService.getProfile().toPromise().then((profile) => {
      if (profile.id === '15179') {
        return true;
      } else {
        this._router.navigate(['**']);
        return false;
      }
    });
  }
}
